import { render, staticRenderFns } from "./PaymentOrderDetail.vue?vue&type=template&id=4c60fc00&scoped=true&"
import script from "./PaymentOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./PaymentOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentOrderDetail.vue?vue&type=style&index=0&id=4c60fc00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60fc00",
  null
  
)

export default component.exports